import { render, staticRenderFns } from "./TipoFaixaSetting.vue?vue&type=template&id=0d5b9545"
import script from "./TipoFaixaSetting.vue?vue&type=script&lang=js"
export * from "./TipoFaixaSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports